import { actionPromiseCreator } from '../helpers';

const createAction = actionPromiseCreator('R_CAT');

export const fetchRCatProject = createAction<void>('FETCH_R_CAT_PROJECT');

export const fetchRCatDataSource = createAction<void>('FETCH_R_CAT_DATA_SOURCE');
